import { UploadUrlResponse } from "toptaal-shared"
import apiClient from "../client"
import {
  Invoice,
  InvoiceDetailResponse,
  InvoiceFilters,
  InvoiceListResponse,
} from "../types/invoices"
import type { DocumentDisposition } from "@/hooks/useFileActions"

export async function getFilteredInvoices({
  filters: activeFilters,
  ...rest
}: InvoiceFilters) {
  return await apiClient
    .post<InvoiceListResponse>("invoicing/invoices/filters", {
      json: {
        ...rest,
        ...(activeFilters && { filters: activeFilters }),
      },
    })
    .json()
}

export async function getInvoice(invoiceId: Invoice["id"]) {
  return await apiClient
    .get<InvoiceDetailResponse>(`invoicing/invoices/${invoiceId}`)
    .json()
}

export async function finalizeInvoice(invoiceId: Invoice["id"]) {
  return await apiClient
    .post<InvoiceDetailResponse>(`invoicing/invoices/${invoiceId}/finalize`)
    .json()
}

export async function sendInvoiceToStudent(invoiceId: Invoice["id"]) {
  return await apiClient
    .post(`invoicing/invoices/${invoiceId}/send_to_student`)
    .json()
}

export async function creditInvoice(invoiceId: Invoice["id"]) {
  return await apiClient
    .post<InvoiceDetailResponse>(`invoicing/invoices/${invoiceId}/credit`)
    .json()
}

export async function getInvoiceDocumentUrl(
  invoiceId: Invoice["id"],
  uploadId: number,
  options: { disposition: DocumentDisposition },
) {
  return await apiClient
    .get<UploadUrlResponse>(
      `invoicing/invoices/${invoiceId}/documents/${uploadId}`,
      { searchParams: { disposition: options.disposition } },
    )
    .json()
}
